import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { BookCover } from "../components/BookCover";
import { StarDisplay } from "../components/StarRating";
import { useAuth } from "../context/AuthContext";
import { Heart } from "lucide-react";
import { toast } from "sonner";
import { t, useLang } from "../lib/i18n";

export default function WishlistPage() {
  useLang();
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    api.get("/me/wishlist").then(({ data }) => setItems(data)).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const remove = async (bookId) => {
    try {
      await api.delete(`/me/wishlist/${bookId}`);
      toast.success(t("wishlist.removed"));
      load();
    } catch {}
  };

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-12 py-12 fade-up" data-testid="wishlist-page">
      <div className="font-mono uppercase tracking-[0.25em] text-xs text-[#4A4030]">{t("wishlist.eyebrow")}</div>
      <h1 className="font-heading text-4xl md:text-5xl text-[#0A0A0A] mt-3 tracking-tight">{t("wishlist.title")}</h1>
      <p className="text-[#4A4030] mt-2 mb-10">{t("wishlist.subtitle")}</p>

      {loading ? (
        <div className="font-mono uppercase tracking-widest text-xs text-[#8C7F65]">{t("common.loading")}</div>
      ) : items.length === 0 ? (
        <div className="border border-dashed border-[rgba(10,10,10,0.16)] p-16 text-center">
          <Heart className="w-7 h-7 mx-auto text-[#8C7F65]" strokeWidth={1.5} />
          <div className="font-heading text-2xl text-[#4A4030] mt-4">{t("wishlist.empty")}</div>
          <Link to="/discover" className="font-mono uppercase tracking-widest text-xs text-[#0A0A0A] hover:underline mt-4 inline-block">{t("library.browse")}</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-6 md:gap-8">
          {items.map((b) => (
            <div key={b.id} className="group" data-testid={`wishlist-${b.id}`}>
              <Link to={`/books/${b.id}`}>
                <BookCover src={b.cover_url} title={b.title} author={b.author} />
              </Link>
              <div className="mt-3 space-y-1">
                <Link to={`/books/${b.id}`} className="font-heading text-base text-[#0A0A0A] leading-tight line-clamp-2 group-hover:text-[#4A4030] transition-colors">{b.title}</Link>
                <div className="font-mono text-[10px] uppercase tracking-widest text-[#4A4030]">{b.author}</div>
                <div className="flex items-center justify-between pt-1">
                  <StarDisplay value={b.avg_rating} size={12} />
                  <button onClick={() => remove(b.id)} className="font-mono uppercase tracking-widest text-[10px] text-[#7C1D1D] hover:underline" data-testid={`wishlist-remove-${b.id}`}>{t("common.remove")}</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
